module.exports = v => (!v && true) || false;